// Login state of a Client User as Keycloak reports it, per
// parrot-media/portal/main#265. The API sends it as keycloak_status on user
// records: the profile's Active flag is what the admin maintains, this is
// whether the person can actually sign in. It is absent when the API could
// not read Keycloak.
export const LOGIN_STATE = {
    ENABLED: 'enabled',
    DISABLED: 'disabled',
    MISSING: 'missing'
};

export const LOGIN_STATE_LABELS = {
    [LOGIN_STATE.ENABLED]: 'Enabled',
    [LOGIN_STATE.DISABLED]: 'Disabled',
    [LOGIN_STATE.MISSING]: 'Not in Keycloak'
};

export const LOGIN_STATE_UNKNOWN_LABEL = 'Unknown';

export const LOGIN_STATE_TITLES = {
    [LOGIN_STATE.ENABLED]: 'This user can sign in to the Portal.',
    [LOGIN_STATE.DISABLED]: 'This user cannot sign in or reset their password.',
    [LOGIN_STATE.MISSING]: 'No Keycloak account carries this username; it was removed in Keycloak. The profile can still be kept or marked Inactive.',
    unknown: 'Keycloak could not be read when this record was loaded.'
};

// Colours: the theme's error red for a disabled login, a dark orange for a
// login that no longer exists, muted grey when the state is unknown.
export const LOGIN_STATE_STYLES = {
    [LOGIN_STATE.ENABLED]: undefined,
    [LOGIN_STATE.DISABLED]: {color: '#b4212d', fontWeight: 600},
    [LOGIN_STATE.MISSING]: {color: '#e65100', fontWeight: 600},
    unknown: {color: 'rgba(33, 33, 33, 0.5)'}
};
